
const namespace = 'workshopsSchedule';
import { Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { FormHelper } from '@/modules/workshops-schedule/models/logic/FormHelper';
import { Registration, AvailableTicketType } from '@/modules/workshops-schedule/models/formModels';
import RestResource from '@/modules/api/RestResource';
import IPaymentRequest from '@/modules/form/interfaces/IPaymentRequest';
import { generateClientIP } from '@/utils/web';

import { countriesData } from './data/ISO_3166-1_countries_pl';

export default abstract class RegistrationFormBase extends Vue {
    @Getter('apiUrl', { namespace: 'configuration' }) protected apiUrl!: string;
    @Getter('currentEventId', { namespace: 'form' }) protected currentEventId!: number;
    @Getter('selectedWorkshopsIds', { namespace }) protected selectedWorkshopsIds!: number[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('setFormDetails', { namespace }) public setFormDetailsInternal: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('setLoading', { namespace }) public setLoading: any;
    @Getter('selectedTicketsIds', { namespace }) public selectedTicketsIds!: number[];
    @Getter('availableTicketsTypes', { namespace }) protected availableTicketsTypes!: AvailableTicketType[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('toogleSelectedTicket', { namespace }) protected toogleSelectedTicket: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('loadFormStateForRegistration', { namespace }) private loadFormStateForRegistration!: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('fetchAvaiableTicketTypes', { namespace }) protected fetchAvaiableTicketTypes: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('fetchCurrentWeekDays', { namespace }) private fetchCurrentWeekDays: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Action('changeEventId', { namespace: 'form' }) private changeEventId: any;

    protected errorMessage = '';
    protected errored = false;
    protected eventId = 1;
    public alertsVisible = false;
    protected errors: any[] = [];
    public alerts: any[] = [];
    public acceptConditions = null;
    protected formHelper = new FormHelper();

    protected showError(message: string) {
        this.alerts.push({ type: 'error', message: message });
        this.alertsVisible = true;
    }

    protected showWarning(message: string) {
        this.alerts.push({ type: 'warning', message: message });
        this.alertsVisible = true;
    }

    protected showInfo(message: string) {
        this.alerts.push({ type: 'info', message: message });
        this.alertsVisible = true;
    }

    protected showSuccess(message: string) {
        this.alerts.push({ type: 'success', message: message });
        this.alertsVisible = true;
    }

    protected closeAlerts() {
        this.alertsVisible = false;
        this.alerts = [];
    }

    public form: Registration = this.formHelper.createEmptyRegistrationForm(this.eventId);

    public get countries() {
        const countries = countriesData
            .map((x: any) => ({ text: x.name_en, value: x.name_en }))
            .sort((x: any, y: any) => x.text.toLowerCase().localeCompare(y.value.toLowerCase()));
        // this.resources.unshift({ text: null, value: this.formField.Tooltip, Hidden: true });
        countries.unshift({ text: 'Polska', value: 'Poland' });
        return countries;
    }

    protected readonly SubmitEventRegistrationFormRequests = this.apiUrl + '/registrations/EventRegistrationForms';
    protected registartionsResource: RestResource<Registration> = new RestResource<Registration>(
        this.SubmitEventRegistrationFormRequests,
        this.onResourceLoading,
        this.onResourceLoadingFinished,
        this.onError,
    );
    protected readonly PaymentRequests = this.apiUrl + '/payments/PaymentRequests';
    protected paymentsResource: RestResource<IPaymentRequest> = new RestResource<IPaymentRequest>(
        this.PaymentRequests,
        this.onResourceLoading,
        this.onResourceLoadingFinished,
        this.onError,
    );

    protected async prepareForm() {
        this.changeEventId(this.eventId);
        const eventId =
            this.$route.query.e ||
            this.$route.query.eventId ||
            this.$route.query.EventId ||
            this.currentEventId.toString();
        if (eventId !== undefined && +eventId !== this.eventId) {
            this.eventId = +eventId as number;
            this.changeEventId(this.eventId);
        }

        generateClientIP();
        await this.fetchCurrentWeekDays();
        await this.fetchAvaiableTicketTypes();

        this.registartionsResource.$on('resourceCreated', this.onRegistartionCreated);
        this.registartionsResource.baseUrl = this.apiUrl + '/registrations/EventRegistrationForms';
        this.paymentsResource.$on('resourceCreated', this.onPaymentCreated);
        this.paymentsResource.baseUrl = this.apiUrl + '/payments/PaymentRequests';

        if (this.$route.query.paymentId) {
            const id = this.$route.query.paymentId.toString();
            const status = this.$route.query.paymentStatus;
            if (status) {
                await this.paymentsResource.patchResource(id, { status: status });
            }

            const payment = await this.paymentsResource.getResource(id);
            if (payment.Status === 'CONFIRMED' || payment.Status === 'COMPLETED') {
                this.cleanUrlParameters();
                this.showSuccess(`Płatność zakończona pomyślnie. Sprawdź swóją skrzynkę e-mail.`);
            } else {
                this.showError('Płatność odrzucona. Spróbuj ponownie.');
                if (payment && payment.EventRegistrationId && payment.EventRegistrationGuid) {
                    // this.cleanUrlParameters();
                    this.$router.push({
                        query: { i: payment.EventRegistrationId.toString(), g: payment.EventRegistrationGuid },
                    });
                }
            }
        }

        if (this.isSessionContinuation) {
            const eventRegistrationId = +this.$route.query.i as number;
            const eventRegistrationGuid = this.$route.query.g as string;

            this.setFormDetails({
                eventRegistrationId: eventRegistrationId,
                eventRegistrationGuid: eventRegistrationGuid,
            });

            await this.fetchAvaiableTicketTypes();

            const form = await this.loadFormStateForRegistration();
            this.form = form as Registration;
            const selectedTicketsIds = [...new Set(this.form.ParticipantData.SelectedTickets.Value.map(x => x))];
            selectedTicketsIds.forEach(ticketTypeId => this.toogleTicketSelection(ticketTypeId));
            // this.cleanUrlParameters();
        } else if (this.isRecommendation) {
            const recommendedBy = this.$route.query.rec as string;
            this.form.ParticipantData.RecommendedBy.Value = recommendedBy;
            this.setFormDetails({
                recommendedBy: recommendedBy,
            });
            await this.fetchAvaiableTicketTypes();
        }

        this.clearSelectedTickets();
        this.form.ParticipantData.SelectedTickets.Value = this.selectedTicketsIds;
    }

    protected getPosType(): string {
        return this.form.ParticipantData.Country.Value === 'Poland' ? 'PayNow' : 'PayU';
    }

    protected cleanUrlParameters() {
        window.history.replaceState(null, '', '/');
    }

    public async onRegistartionCreated(response: any) {
        // this.$router.currentRoute.query;
        // let path = `${window.location.origin}${window.location.pathname}${this.$router.currentRoute.fullPath}`;
        let path = `${window.location.origin}${window.location.pathname}`;
        path = path.replace('//?', '?').replace('/?', '?');

        if (response.status === 'RegistrationPaid') {
            this.cleanUrlParameters();
            this.fetchAvaiableTicketTypes();
            this.showInfo('Your registration is already paid.');

            return;
        }

        this.setFormDetails({
            eventRegistrationId: response.eventRegistrationId,
            eventRegistrationGuid: response.eventRegistrationGuid,
        });

        if (response.unavailableTicketsIds.length > 0) {
            response.unavailableTicketsIds.forEach((x: number) => this.toogleSelectedTicket(x));
            // reload the available tickets
            await this.fetchAvaiableTicketTypes();
            this.showInfo('Some of the selected tickets are not available any more. Please select tickets again.');

            return;
        }

        // const posType = this.form.ParticipantData.Country.Value === 'Poland' ? 'PayNow' : 'PayU';
        const posType = this.getPosType();

        const payment = {
            EventRegistrationId: response.eventRegistrationId,
            EventRegistrationGuid: response.eventRegistrationGuid,
            ClientIp: this.clientIp,
            PosType: posType,
            ContinueUrl: path,
        };

        const paymentResponse = await this.paymentsResource.createNewResource(payment);
        if (!paymentResponse) {
            this.showError('Error during requesting payment. Please try again or contact with the administrator.');
        }
    }

    private async onPaymentCreated(response: any) {
        const path = response.redirectUri;
        // window.open(path, '_blank');
        window.open(path, '_self');
    }

    public get selectedTicketsPriceSum() {
        const selectedTicketIds = this.selectedTicketsIds;
        const availableTicketsTypes = this.availableTicketsTypes;
        const getPrice = function(ticketId: number): number {
            const price = availableTicketsTypes.find(x => x.Id === ticketId)?.CurrentPrice;
            return price ? price : 0;
        };
        const totalPrice = selectedTicketIds.reduce((sum, current) => sum + getPrice(current), 0);

        return totalPrice;
    }

    protected get clientIp() {
        let clientIp = localStorage.getItem('clientIp');
        if (clientIp === undefined || clientIp === null || clientIp === '' || clientIp === 'undefined') {
            clientIp = '127.0.0.1'; // fake IP in case of issuses with getting parameter that is required for the payent
        }

        return clientIp;
    }

    public get ticketsToSelect() {
        let sexTypeId = this.form.ParticipantData.SexTypeId.Value;
        if (!sexTypeId) {
            sexTypeId = 1;
        }
        const ticketTypes = this.availableTicketsTypes.filter(x => x.SexTypeId === sexTypeId && x.IsAvailable);
        return ticketTypes;
    }

    public toogleTicketSelection(ticketId: number) {
        this.toogleSelectedTicket(ticketId);
    }

    protected get isSessionContinuation() {
        return this.$route.query.g !== undefined && this.$route.query.i !== undefined;
    }

    protected get isRecommendation() {
        return this.$route.query.rec !== undefined;
    }

    protected get ticketsSelected(): boolean {
        return this.selectedWorkshopsIds.length < 1;
    }

    protected get eventParticipantSexTypeId(): number | null {
        return this.form.ParticipantData.SexTypeId.Value;
    }

    public setFormDetails(params: any) {
        this.setFormDetailsInternal(params);
    }

    public onResourceLoading() {
        this.setLoading(true);
    }

    public onResourceLoadingFinished() {
        this.setLoading(false);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    protected onError(data: any) {
        console.error(data);
        this.errored = true;
        if (data.error !== undefined) {
            this.showError(data.error.message);
        } else {
            this.showError("We can't submit your form. Please try again later or contact with the administrator.");
        }
    }

    protected clearSelectedTickets() {
        this.selectedTicketsIds?.forEach(ticketId => {
            this.toogleSelectedTicket(ticketId);
            this.selectedTicketsIds.splice(this.selectedTicketsIds.indexOf(ticketId), 1);
        });
        this.form.ParticipantData.SelectedTickets.Value = [];
    }

    public async submit() {
        const observer = this.$refs.observer as any;
        const result = await observer.validate();
        if (!result) {
            return;
        }

        this.form.ParticipantData.EventId.Value = this.currentEventId;
        this.form.DancePartnerData.EventId.Value = this.currentEventId;
        await this.registartionsResource.createNewResource(this.form);
    }
    protected async availableTicketTypesLoaded(response: any) {
        // do nothing
    }

    protected get isWordPressPlugin() {
        return process.env.VUE_APP_IS_WORDPRESS_PLUGIN === 'true';
    }
}
